import classes from "./AddPrizeForm.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import serverPostData from "../../utils/ServerPostData";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import DarkModeContext from "../../store/DarkModeContext";
import { lightModeColors, darkModeColors } from "../../utils/colors";

function PrizeForm(props) {
  const [t, i18n] = useTranslation("prizes");
  const [tg, i18] = useTranslation("global");
  const [name, setName] = useState("");
  const [img, setImg] = useState("");
  const [pointValue, setPointValue] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState(""); 
  const [nameError, setNameError] = useState("");
  const [imgError, setImgError] = useState("");
  const [pointValueError, setPointValueError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [dueDateError, setDueDateError] = useState("");
  const [availability, setAvailability] = useState("");
  const [maxPerUser, setMaxPerUser] = useState("");
  const [maxPerUserError, setMaxPerUserError] = useState("");
  const [availabilityError, setAvailabilityError] = useState("");
  const [wallet, setWallet] = useState("councilWallet");

  const formData = new FormData();
  const navigate = useNavigate();
  const { darkMode} = useContext(DarkModeContext);
  const { textColor, backgroundColor, cardColor } = darkMode ? darkModeColors : lightModeColors;

  function cancelHandler() {
    props.cancel();
  }

  function handleDateChange(ev) {
    if (!ev.target["validity"].valid) return;
    const dt = new Date(ev.target.value).toISOString();
    setDueDate(dt);
  }

  function confirmHandler(event) {
    event.preventDefault();
    setNameError("");
    setImgError("");
    setPointValueError("");
    setDueDateError("");
    setDescriptionError("");
    setAvailabilityError("");
    setMaxPerUserError("");

    if ("" === name) {
        console.log(img);
      setNameError(tg("prizes.input_error.name"));
      return;
    }
    if ("" === img) {
        setImgError(tg("prizes.input_error.img"));
        return;
    }
    if ("" === pointValue) {
      setPointValueError(tg("prizes.input_error.point"));

      return;
    }
    if (dueDate <= new Date().toISOString()) {
      setDueDateError(tg("prizes.input_error.dueDate"));
      return;
    }
    if ("" === description) {
      setDescriptionError(tg("prizes.input_error.description"));
      return;
    }

    if ("" === dueDate) {
      setDueDateError(tg("prizes.input_error.dueDate"));
      return;
    }
    if ("" === availability) {
      setAvailabilityError(tg("prizes.input_error.availability"));
      return;
    }
    if ("" === maxPerUser) {
      setMaxPerUserError(tg("prizes.input_error.maxPerUser"));
      return;
    }
    

    if (
      nameError === "" &&
      imgError === "" &&
      pointValueError === "" &&
      descriptionError === "" &&
      dueDateError === "" &&
      availabilityError === "" &&
      maxPerUserError === ""
    ) {
      
        formData.append("title", name);
        formData.append("image", img);
        formData.append("pointValue", pointValue);
        formData.append("description", description);
        formData.append("dueDate", dueDate);
        formData.append("quantity", availability);
        formData.append("maxPerUser", maxPerUser);
        formData.append("adminID", localStorage.getItem("userId"));
        formData.append("wallet", wallet);
        console.log(formData);

      //console.log(dataToSend);
      //console.log('SUCCESS');
      const serverResponse = serverPostData("/dashboard-add-prize", formData);
      serverResponse.then((response) => {
        let data = response;

        if (data.status === 200) {
          alert(tg("global.general.success"));
          //refresh the page
          window.location.reload();
          //navigate("/prize");
          //<NavLink to="/contact"/>;
          //<Route  path={'/contact'} element={<Navigate to="/contact" />} />
          //eactDOM.render(<Navigate to="/contact" />, document.getElementById('root'));
          //alert()
        } else {
          alert(tg("global.general.error"));
        }
      });

      props.confirm();
    }
  }

  return (
    <div className={classes.form} style= {{'--card-color': cardColor}}>
      <p>{tg("prizes.add.new_prize")}</p>
      <form id="add_prize" onSubmit={confirmHandler}>
        <input
          className={classes.fieldBox}
          type="text"
          placeholder={tg("prizes.form.name")}
          name="fname"
          style= {{"--text-color": textColor}}
          onChange={(e) => setName(e.target.value)}
        />
        <div>
        <label className={classes.errorLabel}>{nameError}</label>
</div>
<div className={classes.fieldBox}>
        <div className={classes.timeBox}>
          <label
            style={{
              color: "darkgray",
              fontSize: ".8rem",
              marginRight: ".5cm",
            }}
          >
            {tg("prizes.form.image")}
          </label>
          <input
            
            type="file"
           
            onChange={(e) => setImg(e.target.files[0])}
          />

        </div>
        </div>
        <div>
        <label className={classes.errorLabel}>{imgError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="pointValue">
            {tg("prizes.form.point")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setPointValue(e.target.value)}
          />
        </div>

       
        <div>
        <label className={classes.errorLabel}>{pointValueError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="type">
            {tg("prizes.form.type")}
          </label>
          <select
          className={classes.select_button}
          name="PreviousReceiver"
          onChange={(e) => setWallet(e.target.value)}
        >
          <option value="councilWallet">{tg("global.wallet.walletCouncil")}</option>
          <option value="schoolWallet">{tg("global.wallet.walletSchool")}</option>
          <option value="marketWallet">{tg("global.wallet.walletMarket")}</option>

          
        </select>
        
        </div>

        <div className={classes.fieldBox} >
        <div className={classes.timeBox} style={{display:"flex", alignItems:"center"}}>
          <label
            style={{
              color: "darkgray",
              fontSize: ".8rem",
              marginRight: ".5cm",
            }}
          >
            {tg("prizes.form.dueDate")}
          </label>
          <input
            type="datetime-local"
            defaultValue={new Date().toISOString().split(".")[0].slice[(0, 16)]}
            onChange={(e) => handleDateChange(e)}
          />
        </div>
        </div>
        <div>
        <label className={classes.errorLabel}>{dueDateError}</label>

        </div>

        <input
          className={classes.fieldBox}
          type="text"
          placeholder={tg("prizes.form.description")}
          name="fname"
          onChange={(e) => setDescription(e.target.value)}
        />
        <div>
        <label className={classes.errorLabel}>{descriptionError}</label>
        </div>

            

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="av">
            {tg("prizes.form.availability")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setAvailability(e.target.value)}
          />
        </div>
      
        <div>
        <label className={classes.errorLabel}>{availabilityError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="av">
            {tg("prizes.form.maxPerUser")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setMaxPerUser(e.target.value)}
          />
        </div>
      
        <div>
        <label className={classes.errorLabel}>{maxPerUserError}</label>
        </div>


        <input
          type="submit"
          className={classes.submit_button}
          value={tg("global.general.confirm")}
        />
        <input
          type="button"
          className={classes.cancel_button}
          onClick={cancelHandler}
          value={tg("global.general.cancel")}
        />
      </form>
    </div>
  );
}

export default PrizeForm;
